import React from 'react';
import { DeviceSkeleton } from "../DeviceSkeleton";
export var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
    isFetching = _ref.isFetching,
    isError = _ref.isError;
  if (isFetching) {
    return /*#__PURE__*/React.createElement(DeviceSkeleton, null);
  }
  if (isError) {
    return null;
  }
  return children;
};